import React from 'react'
import QuestionBankComp from '../../Components/QuestionBank/QuestionBankComp'


function  QuestionBank() {
    return <>
       < QuestionBankComp />
    </>
}

export default  QuestionBank